import React from "react";

const AlertField = (props) => {
  return (
    props.alert && (
      <div
        className={`sticky-top alert alert-${props.alert.type} alert-dismissible m-0 p-2 fade show`}
        role="alert"
      >
        {props.alert.message}
      </div>
    )
  );
};

export default AlertField;
